import { useState } from "react";
import { Provider, TaxProfessional, IntialtaxProfessional } from '../components/partner-enrollment/enrollment-form-context'
import PartnerProgramAccount from "../components/partner-enrollment/program-account";
import PartnerBusinessInformation from "../components/partner-enrollment/business-information";
import PartnerStoreFrontQuestion from "../components/partner-enrollment/store-front-question";
import PartnerDefaultMailingAddress from "../components/partner-enrollment/default-mailing-address"
import PartnerProfessionInformation from "../components/partner-enrollment/profession-information";
import PartnerInsurance from "../components/partner-enrollment/insurance";
import PartnerExperience from "../components/partner-enrollment/experience";
import PartnerLanguage from "../components/partner-enrollment/language";
import PartnerSoftware from "../components/partner-enrollment/software";
import PartnerApplicationStatus from "../components/partner-enrollment/status";
import PartnerTaskRiskReport from "../components/partner-enrollment/task-risk-report";
import PartnerSignature from "../components/partner-enrollment/signature";
import PartnerTaxInformatioAuthorization from "../components/partner-enrollment/tax-information-authorization";
import PartnerFinished from "../components/partner-enrollment/status/finished";
import Footer from "../components/footer";

export const motionContainer = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.3 } },
  exit: { opacity: 0, transition: { duration: 0.1 } }
};

const renderStep = (step: number, completedPerecent: number) => {
  switch (step) {
    case 0:
      return <PartnerProgramAccount />;
    case 1:
      return <PartnerBusinessInformation progressPercent={completedPerecent} />;
    case 2:
      return <PartnerStoreFrontQuestion progressPercent={completedPerecent} />;
    case 3:
      return <PartnerDefaultMailingAddress progressPercent={completedPerecent} />;
    case 4:
      return <PartnerProfessionInformation progressPercent={completedPerecent} />;
    case 5:
      return <PartnerInsurance progressPercent={completedPerecent} />;
    case 6:
      return <PartnerExperience progressPercent={completedPerecent} />;
    case 7:
      return <PartnerLanguage progressPercent={completedPerecent} />;
    case 8:
      return <PartnerSoftware progressPercent={completedPerecent} />;
    case 9:
      return <PartnerApplicationStatus progressPercent={completedPerecent} />
    case 10:
      return <PartnerTaskRiskReport progressPercent={completedPerecent}/>;
    case 11:
      return <PartnerSignature progressPercent={completedPerecent} />;
    case 12:
      return <PartnerTaxInformatioAuthorization progressPercent={completedPerecent} />;
    case 13:
      return <PartnerFinished />;
    default:
      return null;
  }
};

const PartnerEnrollment = () => {
  const [taxProfessionalId, setTaxProfessionalId] = useState("");
  const [enrollmentId, setEnrollmentId] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  const [taxProfessional, setTaxProfessional] = useState<TaxProfessional>(IntialtaxProfessional);
  const [applicationStatus, setApplicationStatus] = useState("")
  const [s3key, setS3Key] = useState("");
  const [s3Bucket, setS3Bucket] = useState("");
  const [nextFormId, setNextFormId] = useState("");
  const [partnerType, setPartnerType] = useState("");

  const next = () => {
    if (currentStep === 14) {
      setCurrentStep(0);
      return;
    }
    setCurrentStep(currentStep + 1);
  };

  const NextEnrollmentAction = (action: string) => {
    if(action === 'CompleteBusinessInformation') {
      setCurrentStep(1)
    }
    if(action === 'CompleteProfessionalInformation') {
      setCurrentStep(4)
    }
    if(action === 'WaitForApplicationApproval') {
      setCurrentStep(9)
    }
    if(action === 'CompleteServiceAgreement') {
      setCurrentStep(9)
    }
    if(action === 'CompleteFormW9') {
      setCurrentStep(12)
    }
  }

  const completedPerecent = (currentStep / 13) * 100;
  return (
    <Provider
      value={{
        s3key,
        setNextFormId,
        nextFormId,
        setS3Key,
        s3Bucket,
        setS3Bucket,
        next,
        enrollmentId,
        setEnrollmentId,
        organizationId,
        setOrganizationId,
        setTaxProfessional,
        taxProfessional,
        taxProfessionalId,
        setTaxProfessionalId,
        applicationStatus,
        setApplicationStatus,
        NextEnrollmentAction,
        setPartnerType,
        partnerType
      }}
    >
       <>
      <div className="page-container">
      <main>{renderStep(currentStep, completedPerecent)}</main>
      </div>
      <div className="my-2">
      <Footer/>
      </div>
      </>
    </Provider>
  );
};
export default PartnerEnrollment;
